module.exports = __webpack_public_path__ + "img/SES_192280255.ac3b861c.jpg";